import { setValue } from '../../../utils/beacon';
const initState = {
    materialList: [],
    currentMaterial: null,
    userOriginImage: '',
    qrCodeUrl: '',
    currentBusiId: '',
};
export const SET_MATERIAL_LIST = 'SET_MATERIAL_LIST';
export const SET_CURRENT_MATERIAL_LIST = 'SET_CURRENT_MATERIAL_LIST';
export const SET_USER_ORIGIN_IMAGE = 'SET_USER_ORIGIN_IMAGE';
export const SET_QRCODE_URL = 'SET_QRCODE_URL';
export const SET_CURRENT_BUSI_ID = 'SET_CURRENT_BUSI_ID';
export const setMaterialList = (list) => ({
    type: SET_MATERIAL_LIST,
    payload: list,
});
export const setCurrentMaterialList = (info) => {
    setValue('MATERIAL_ID', info === null || info === void 0 ? void 0 : info.busiId);
    return {
        type: SET_CURRENT_MATERIAL_LIST,
        payload: info,
    };
};
export const setUserImage = (image) => ({
    type: SET_USER_ORIGIN_IMAGE,
    payload: image,
});
export const setQRCodeUrl = (image) => ({
    type: SET_QRCODE_URL,
    payload: image,
});
export const setCurrentBusiId = (id) => ({
    type: SET_CURRENT_BUSI_ID,
    payload: id,
});
const ganPlayReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_MATERIAL_LIST:
            return Object.assign(Object.assign({}, state), { materialList: action.payload });
        case SET_CURRENT_MATERIAL_LIST:
            return Object.assign(Object.assign({}, state), { currentMaterial: action.payload });
        case SET_USER_ORIGIN_IMAGE:
            return Object.assign(Object.assign({}, state), { userOriginImage: action.payload });
        case SET_QRCODE_URL:
            return Object.assign(Object.assign({}, state), { qrCodeUrl: action.payload });
        case SET_CURRENT_BUSI_ID:
            return Object.assign(Object.assign({}, state), { currentBusiId: action.payload });
        default:
            return state;
    }
};
export default ganPlayReducer;
